import styles from "./style.module.css";

let nextimg = (
  <svg
    width="9"
    height="11"
    viewBox="0 0 9 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9 5.36275L0.75 10.1259L0.75 0.59961L9 5.36275Z" fill="#55575A" />
  </svg>
);

let backimg = (
  <svg
    width="9"
    height="11"
    viewBox="0 0 9 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M-2.08203e-07 5.63725L8.25 0.874111L8.25 10.4004L-2.08203e-07 5.63725Z"
      fill="#55575A"
    />
  </svg>
);


// Creator : Team E - yosef schmidt
function ButtonListClass({ pageActive, totalPages, setPaginationData, from }) {

  const upMove = () => pageActive > 1 ? setPaginationData(prev => { localStorage[from] = pageActive - 1; return { ...prev, pageToShow: pageActive - 1 } }) : null

  const downMove = () => pageActive !== totalPages ? setPaginationData(prev => { localStorage[from] = pageActive + 1; return { ...prev, pageToShow: pageActive + 1 } }) : null


  return (

    <div className={styles["muneList"]} >
      <div onClick={upMove} className={styles["box"]} >
        <div className={styles["backbox"]}>
          <div className={`${styles["upbox"]} ${styles[backimg === 0 ? "active" : ""]} `} >
            {backimg}
          </div>
        </div>
      </div>

      {[...Array(totalPages)].map((v, i) =>
        <div key={`${i}k`} onClick={() => setPaginationData(prev => { localStorage[from] = i + 1; return { ...prev, pageToShow: i + 1 } })} className={styles["box"]} >
          <div className={styles["backbox"]}>
            <div className={`${styles["upbox"]} ${styles[i + 1 === pageActive ? "active" : ""]} `}>
              {i + 1}
            </div>
          </div>
        </div>
      )}

      <div onClick={downMove} className={styles["box"]}  >
        <div className={styles["backbox"]}>
          <div className={`${styles["upbox"]} ${styles[nextimg === 0 ? "active" : ""]} `} >
            {nextimg}
          </div>
        </div>
      </div>
    </div>
  );
}
export default ButtonListClass;



// function OneButtonListClass(txt, id, isactive) {
//   return (
//     <div className={styles["box"]} id={id}>
//       <div className={styles["backbox"]}>
//         <div className={"upbox " + ((txt == isactive) ? "active" : "")}>
//           <div id="imagebacknext">{txt}</div>

//         </div>
//       </div>
//     </div>
//   );
// }